<app-input-text [form]="form" [hint]="hint" [label]="label" [name]="name" [placeholder]="placeholder" [type]="hide ? 'password' : 'text'"
                icon="password">
  <button (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide" mat-icon-button suffix
          tabindex="-1">
    <mat-icon class="text-700 material-symbols-outlined">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
  </button>
</app-input-text>
